// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.publications-container {
  padding: 2rem;
}

.publications-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}

.publications-header h1 {
  /* font-size: 2rem; */
  font-weight: 700;
  color: #374151;
}

/* Aligner les marges du TabNav sur la page Commandes */
.publications-container .tab-nav {
  margin-bottom: 3rem;
}

/* Aligner la marge du button-group sur la page Commandes */
.publications-container .button-group {
  margin-top: 0;
  margin-bottom: 3rem;
}

/* Loading */
.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  min-height: 300px;
  background-color: #f9fafb;
  border-radius: 8px;
  margin-top: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.loading-indicator .spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e5e7eb;
  border-top-color: #da7027;
  border-radius: 50%;
  animation: publications-spin 1s linear infinite;
  margin-bottom: 1.5rem;
}

@keyframes publications-spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-indicator p {
  color: #6b7280;
  font-size: 1.6rem;
  font-weight: 500;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/Publications.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX","sourcesContent":[".publications-container {\n  padding: 2rem;\n}\n\n.publications-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n}\n\n.publications-header h1 {\n  /* font-size: 2rem; */\n  font-weight: 700;\n  color: #374151;\n}\n\n/* Aligner les marges du TabNav sur la page Commandes */\n.publications-container .tab-nav {\n  margin-bottom: 3rem;\n}\n\n/* Aligner la marge du button-group sur la page Commandes */\n.publications-container .button-group {\n  margin-top: 0;\n  margin-bottom: 3rem;\n}\n\n/* Loading */\n.loading-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  min-height: 300px;\n  background-color: #f9fafb;\n  border-radius: 8px;\n  margin-top: 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.loading-indicator .spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #e5e7eb;\n  border-top-color: #da7027;\n  border-radius: 50%;\n  animation: publications-spin 1s linear infinite;\n  margin-bottom: 1.5rem;\n}\n\n@keyframes publications-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-indicator p {\n  color: #6b7280;\n  font-size: 1.6rem;\n  font-weight: 500;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
